import { useLocation } from "react-router-dom";
import { BackButton } from "./BackButton";
import { useBackToValue } from "./BackToContext";
import { moduleListPath } from "@/lib/moduleListPath";


/**
 * Global sub-header rendered under the main Topbar on every nested route.
 * Provides a prominent, labeled "Back / عودة" action wired into the
 * DirtyNav guard. Hidden only on true top-level destinations (dashboard,
 * root) to avoid showing a redundant "back to dashboard" on the dashboard.
 */
const ROOT_PATHS = new Set<string>([
  "/",
  "/dashboard",
  "/companies",
  "/auth",
]);

export const AppSubHeader = () => {
  const { pathname } = useLocation();
  const backTo = useBackToValue();
  // Hide on top-level destinations only. Every nested route (depth >= 2)
  // and every non-root single-segment page (e.g. /profile, /ai-advisor)
  // gets a prominent back button.
  if (ROOT_PATHS.has(pathname)) return null;

  return (
    <div className="sticky top-14 z-20 bg-card/80 backdrop-blur border-b border-border h-11 flex items-center px-2 sm:px-4 print:hidden">
      <BackButton fallback={backTo ?? moduleListPath(pathname) ?? "/dashboard"} />
    </div>
  );
};
